module.exports = __webpack_public_path__ + "img/mini-004.bde157b5.jpg";